import React from 'react';
import { Link } from 'react-router-dom'; // Nécessaire pour faire fonctionner le bouton

const Home = () => {
  return (
    <div className="bg-black text-white">
      {/* SECTION ACCUEIL */}
      <section className="relative h-screen flex items-center justify-center">
        <div className="absolute inset-0 z-0">
          <img src="/assets/hero-bg.jpg" alt="Luxe Cars" className="w-full h-full object-cover opacity-50" />
          <div className="absolute inset-0 bg-black opacity-40"></div>
        </div>
        
        <div className="relative z-10 text-center px-6">

          <h1 className="text-5xl md:text-7xl font-bold mb-6">
            Top Car, <br/>
            <span className="text-orange-600 italic">la route commence ici</span>
          </h1>
          <p className="text-lg md:text-xl text-gray-300 mb-10 max-w-2xl mx-auto">
            Votre partenaire de confiance pour l'achat et l'importation de véhicules de qualité supérieure à Kinshasa.
          </p>
          <div className="flex flex-col md:flex-row gap-4 justify-center">
            {/* RÉPARATION : Utilisation de Link au lieu de <a> pour ouvrir la page Nos Véhicules */}
            <Link to="/vehicules" className="bg-orange-600 hover:bg-orange-700 text-white px-10 py-4 

rounded-lg font-bold transition">
              Découvrir nos véhicules
            </Link>
            <a href="#contact" className="border-2 border-white hover:bg-white hover:text-black text-white px-10 py-4 rounded-lg font-bold transition">
              Contactez-nous
            </a>
          </div>
        </div>
      </section>

      {/* NOUVELLE SECTION : PRÉSENTATION (QUI EST TOP CAR) */}
      <section className="py-20 bg-black border-b border-zinc-900 px-6">
        <div className="container mx-auto max-w-4xl">
          <div className="text-center mb-12">

            <h2 className="text-orange-600 font-bold tracking-widest uppercase mb-4">Qui est Top Car</h2>
            <div className="h-1 w-20 bg-orange-600 mx-auto"></div>
          </div>
          
          <div className="space-y-8 text-gray-300 text-lg leading-relaxed">
            <p>
              Basée à Kinshasa, <span className="text-white font-bold">Top Car</span> est une agence spécialisée dans l’achat et l’importation de véhicules neufs et d’occasion depuis plus de <span className="text-orange-600 font-bold">20 ans</span>.
            </p>
            
            <p>
              Avec plus de <span className="text-white font-bold">150 

clients satisfaits</span>, nous avons bâti notre réputation sur la confiance, la transparence et la qualité de service. De la recherche du véhicule à la livraison finale, nous accompagnons nos clients à chaque étape avec professionnalisme et efficacité.
            </p>

            <div className="grid md:grid-cols-2 gap-4 pt-6">
              <div className="flex items-center gap-3">
                <span className="text-orange-600 font-bold">✔</span> 
                <span>Plus de 20 ans d’expérience</span>
              </div>
              <div className="flex items-center gap-3">
                <span className="text-orange-600 font-bold">✔</span> 
                <span>Plus de 150 véhicules 

livrés avec succès</span>
              </div>
              <div className="flex items-center gap-3">
                <span className="text-orange-600 font-bold">✔</span> 
                <span>Un réseau international de fournisseurs fiables</span>
              </div>
              <div className="flex items-center gap-3">
                <span className="text-orange-600 font-bold">✔</span> 
                <span>Un service personnalisé et sécurisé</span>
              </div>
            </div>

            <p className="text-center pt-8 font-bold text-white italic">
              Top Car – Votre partenaire de confiance pour l’importation automobile à Kinshasa.

            </p>
          </div>
        </div>
      </section>

      {/* SECTION POURQUOI CHOISIR TOP CAR */}
      <section id="about" className="py-24 bg-zinc-950 px-6">
        <div className="container mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-center mb-16">
            Pourquoi choisir <span className="text-orange-600 font-extrabold">TOP CAR ?</span>
          </h2>
          
          <div className="grid md:grid-cols-3 gap-10">
            {/* Qualité Garantie */}
            <div className="bg-zinc-900 p-8 

rounded-2xl border border-zinc-800 hover:border-orange-600 transition">
              <div className="text-orange-600 text-4xl mb-6">🛡️</div>
              <h3 className="text-2xl font-bold mb-4">Qualité garantie</h3>
              <p className="text-gray-400 leading-relaxed">
                Chaque véhicule de notre parc subit une inspection rigoureuse. Nous ne sélectionnons que l'excellence pour vous assurer une conduite sereine et une longévité moteur exceptionnelle.
              </p>
            </div>

            {/* Large Sélection */}
            <div className="bg-zinc-900 p-8 rounded-2xl border border-zinc-800 hover:border-orange-600 transition">
              <div className="text-orange-600 text-4xl mb-6">🚗</div>

              <h3 className="text-2xl font-bold mb-4">Large sélection</h3>
              <p className="text-gray-400 leading-relaxed">
                De la citadine économique au SUV de luxe en passant par les berlines de prestige, nous disposons d'un catalogue varié répondant à tous les besoins et tous les budgets.
              </p>
            </div>

            {/* Import Professionnel */}
            <div className="bg-zinc-900 p-8 rounded-2xl border border-zinc-800 hover:border-orange-600 transition">
              <div className="text-orange-600 text-4xl mb-6">🌐</div>
              <h3 className="text-2xl font-bold mb-4">Import professionnel</h3>
              <p className="text-gray-400 leading-relaxed">

                Nous maîtrisons toute la chaîne logistique d'importation. Profitez d'un service clé en main, de la commande à l'étranger jusqu'au dédouanement et la livraison à Kinshasa.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER COMPLET */}
      <footer id="contact" className="bg-black py-16 px-6 border-t border-zinc-900">
        <div className="container mx-auto grid md:grid-cols-2 gap-12">
          <div>
            <h3 className="text-orange-600 text-2xl font-bold mb-8">Contact</h3>
            <div className="space-y-4 text-gray-300">

              <p className="flex items-center gap-4"><span>📞</span> +243 828 706 717</p>
              <p className="flex items-center gap-4"><span>📧</span> contact@topcar.cd</p>
              <p className="flex items-center gap-4">
                <span>📍</span> Silikin Village, concession COTEC, sur Socimat / Gombe
              </p>
            </div>
          </div>

          <div className="md:text-right flex flex-col md:items-end justify-between">
            <div>
              <h3 className="text-2xl font-bold mb-4 italic">Top Car, la route commence ici</h3>
              <p className="text-orange-600 font-bold mb-6">Suivez-nous</p>
              <a 

                href="https://www.facebook.com/profile.php?id=61576964318773" 
                target="_blank" 
                className="inline-flex items-center gap-3 bg-zinc-800 hover:bg-blue-600 px-8 py-3 rounded-full transition font-bold"
              >
                <span>f</span> Facebook
              </a>
            </div>
            <p className="mt-12 text-zinc-600 text-sm">© 2026 Agence TOP CAR</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
